import React, { FC, useState } from 'react';
import styled from 'styled-components';
import option_icon from '../../../assets/options_icon.svg';
import { ILifeStyle } from '../../../store/lifeStyle/interface';
import { IStoreCategory } from '../../../store/shopping/interface';
import { DropdownContent } from '../../../component/dropDown';
import { useNavigate } from 'react-router-dom';

type ICategoryList = {
  categoryItems?: IStoreCategory | ILifeStyle;
  currentTab: string;
  handleEditClick: () => void;
  handleDeleteClick: () => void;
};

export const CategoryListCard: FC<ICategoryList> = ({
  categoryItems,
  currentTab,
  handleEditClick,
  handleDeleteClick
}) => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const handleDropdownView = (
    e: React.MouseEvent<HTMLDivElement | HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    setShowDropdown((prev) => !prev);
  };
  const handleView = () => {
    if (currentTab === 'Shopping') return;
    navigate(
      `/categories/all-services/${(categoryItems as ILifeStyle)?.title}/${
        categoryItems?._id
      }`,
      {
        state: {
          categoryId: categoryItems?._id,
          categoryName: (categoryItems as ILifeStyle).title
        }
      }
    );
  };

  return (
    <Card onClick={handleView}>
      <StoreImage src={categoryItems?.file.url} />
      <DeleteBtn
        onClick={handleDropdownView}
        onDoubleClick={() => setShowDropdown(false)}
      >
        <Icon src={option_icon} />
        <CustomDropdownContent show={showDropdown}>
          <DropdownItem
            onClick={(e) => {
              handleDropdownView(e);
              handleEditClick();
            }}
          >
            Edit
          </DropdownItem>
          <DropdownItem
            onClick={(e) => {
              handleDropdownView(e);
              handleDeleteClick();
            }}
          >
            Delete
          </DropdownItem>
        </CustomDropdownContent>
      </DeleteBtn>
      <StoreDetails>
        <StoreHeader>
          <StoreName>
            {currentTab === 'Lifestyle'
              ? (categoryItems as ILifeStyle)?.title
              : (categoryItems as IStoreCategory)?.name}
          </StoreName>
        </StoreHeader>
      </StoreDetails>
    </Card>
  );
};

const Card = styled.article`
  background: #ffffff;
  border-radius: 16px;
  position: relative;
  padding: 8px;
  width: calc(30.33% - 16px);
  margin: 0px 10px;
  margin-bottom: 48px;
  @media (max-width: 1000px) {
    width: calc(45% - 16px);
    margin: 0px 15px;
    margin-bottom: 48px;
  }
  @media (max-width: 730px) {
    width: 100%;
    margin: 0;
    margin-bottom: 48px;
  }
`;
const StoreImage = styled.img`
  border-radius: 16px;
  width: 100%;
  height: 200px;
  object-fit: cover;
  background-color: #c4c4c4;
`;
const DeleteBtn = styled.div`
  position: absolute;
  right: 24px;
  top: 16px;
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
`;
const Icon = styled.img`
  max-height: 48px;
  max-width: 48px;
`;

const StoreDetails = styled.div`
  padding: 23px 16px 0px 16px;
`;

const StoreHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const StoreName = styled.h3`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  text-transform: capitalize;
`;

const CustomDropdownContent = styled(DropdownContent)`
  border-radius: 2px;
  top: 0px;
  right: 34px;
  min-width: 125px;
`;
const DropdownItem = styled.button`
  background-color: transparent;
  border: none;
  text-align: center;
  width: 100%;
`;
